import React from 'react'
import TouchLink from '../../utils/ope-touch-link'
import TouchButton from '../../utils/ope-touch-button'
import ProductListItem from './product-list-item'
import Batch from '../batch/batch'
import ProductListTotal from './product-list-total'
import Config from '../../../config'
import Sticky from '../../../utils/sticky'
import AdobeAnalytics from '../../../utils/adobe-analytics'
import Paginator from '../../utils/paginator'
import Modal from '../../utils/ope-modal'
import OrderStore from '../../../stores/order-store'
import UploadStore from '../../../stores/upload-store'
import SelectorActions from '../../../actions/selector-actions'
import ImageStore from '../../../stores/image-store'
import createReactClass from 'create-react-class'


function getOrderStoreItems() {
	return OrderStore.getItems();
}

function getOrderStoreBatchItems() {
	return OrderStore.getBatchItems();
}

function getUploadStoreData() {
	return UploadStore.getData()
}

function getCropLowresWarningSeen() {
	return OrderStore.getCropLowresWarningSeen();
}

var ProductList = createReactClass({

    mounted: false,

	getInitialState: function() {
		return {items: getOrderStoreItems(), batchItems: getOrderStoreBatchItems(), navEnabled: false, expandedListItem: null, batchExpanded: false,  cropWarning: false, lowResWarning: false, page: 1, perPage: Config.ProductItemsPerPage, cropLowResWarningSeen: getCropLowresWarningSeen() };
	},
	_onOrderStoreItemsChange: function() {
		this.setState({items: getOrderStoreItems(), batchItems: getOrderStoreBatchItems(), cropLowResWarningSeen: getCropLowresWarningSeen()});
	},
	_onUploadStoreChange: function() {
		var navEnabled = this.navEnabled();
		if (navEnabled !== this.state.navEnabled) {
			this.setState({navEnabled: navEnabled});
		}
	},
	navEnabled: function () {
		var upload = getUploadStoreData();
		var navEnabled = false;

		//If there has been added any images to the uploader, all of them must be registered before enabling the next step button
		if (upload.totalImagesToUpload > 0) {
			navEnabled = (upload.totalImagesToUpload <= upload.totalImagesRegistered);
		} else {
			//If there are no items, do not enable the next step button
			navEnabled = this.state.items.length > 0;
		}

		return navEnabled;
	},
	componentWillMount: function () {
		OrderStore.addChangeListener(this._onOrderStoreItemsChange);
		UploadStore.addChangeListener(this._onUploadStoreChange);
	},
	componentWillUnmount: function() {
        this.mounted = false;
		OrderStore.removeChangeListener(this._onOrderStoreItemsChange);
		UploadStore.removeChangeListener(this._onUploadStoreChange);
	},

	_checkOrderItemsForWarnings: function() {
		if(sessionStorage) {
			// If warnings have already been shown, do nothing
			if(!sessionStorage.getItem("warningsHasBeenShown")) {
				// Else, check if any warnings exists in order items information property
				var items = this.state.items,
					lowRes = false, autoCrop = false;
				for(var i = 0; i <items.length; i++) {
					var item = items[i];
					if(item.getLowResWarning()) {
						lowRes = true;
					}
					if(item.getAutoCropWarning()) {
						autoCrop = true;
					}
				}

				//Log analytics data
				var warningList = [];
				if (lowRes) {
					warningList.push("Low resolution images");
				}
				if (autoCrop) {
					warningList.push("Cropped photos");
				}

				AdobeAnalytics.setLowResAndAutoCropWarnings(warningList);

				this.setState({lowResWarning: lowRes, cropWarning: autoCrop });
				//sessionStorage.setItem('warningsHasBeenShown', 'true');
			}

		}
	},

	shouldShowWarnings: function () {
		if (this.state.cropLowResWarningSeen) {
			return false;
		}
		if (this.state.lowResWarning || this.state.cropWarning) {
			return true;
		}
		return false;
	},
	componentDidMount: function() {
        this.mounted = true;
		if (sessionStorage.getItem("lowResWarning")) {
			sessionStorage.removeItem('warningsHasBeenShow');
		}
		this._checkOrderItemsForWarnings();
		var footerNavs = document.getElementsByClassName('ope-section__footer__nav');
	    for (var i = 0; i < footerNavs.length; i++) {
    		Sticky.setSticky(footerNavs[i], 'stikybottom', 600);
    	}
    	this.setState({navEnabled: this.navEnabled()});
	},

	componentDidUpdate: function() {
		if(!sessionStorage.getItem("warningsHasBeenShown")) {
			//this._checkOrderItemsForWarnings();
		}
	},

	_disableWarnings: function(warningType) {
		var stateObj = {
			lowResWarning: false,
			cropWarning: false
		};
		if (this.mounted) {
			this.setState(stateObj);
		}
	},

	batchToggleHandler: function() {
		SelectorActions.toggleOrderBatchState(!this.state.batchExpanded);
		this.setState({batchExpanded: !this.state.batchExpanded });
	},

	editHandler: function(event, childInstance) {
		// Store original position.
		childInstance.props.item.optionsStored = JSON.stringify(childInstance.props.item.options);

		// Position: childInstance.props.item.options.position
		var expandedListItem = this.state.expandedListItem,
			items = this.state.items;
		// If there is another product-list-item that is expanded
		if(expandedListItem) {
			// close the opened list-item before opening the new one
			// If for some reason the expandedListItem is already open, this should not really happen but if it does
			// dont close it, just keep it open
			if(expandedListItem !== childInstance) {
				expandedListItem.setState({editExpanded: false });
			}
		}
		this.setState({expandedListItem: childInstance});
		childInstance.setState({editExpanded: true, animateDetailedOpen: true });
	},

	closeHandler: function(event, childInstance) {
		childInstance.setState({editExpanded: false, animateDetailedClose: true });
		this.setState({expandedListItem: null });
	},
	itemInBatch: function(item) {
		var batchItems = this.state.batchItems,
			i = 0, len = batchItems.length;

		for(i; i < len; i++) {
			if(batchItems[i].id == item.id) {
				return true;
				break;
			}
		}
		return false;
	},
	getPaginationStartIndex: function () {
		return (this.state.page-1) * this.state.perPage;
	},
	isItemOnCurrentPage: function (index) {
		var startIndex = this.getPaginationStartIndex();
		if (index >= startIndex && index < startIndex+this.state.perPage) {
			return true;
		}
		return false;
	},
	updatePage: function (page) {
		if (this.mounted) {
			this.setState({page: page});
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		}
	},
	render: function() {
		var self = this;
		var editHandler = this.editHandler,
			closeHandler = this.closeHandler,
			batchExpanded = this.state.batchExpanded,
			instance = this, inBatch = false, items,
			cropWarning, lowResWarning;

		var items = [];
		var firstItem;

		for (var i = 0; i < this.state.items.length; i++) {
			var item = this.state.items[i];

			if(instance.state.batchExpanded) {
				inBatch = instance.itemInBatch(item);
			}
			if (self.isItemOnCurrentPage(i)) {
				if (firstItem === undefined) {
					firstItem = item;
				}
				var image = ImageStore.getImageById(item.getImageId());
				if (image) {
					image.setVisible(true);
				}
				items.push(<ProductListItem item={item} key={item.getId()} editHandler={editHandler}
						closeHandler={closeHandler} batchExpanded={batchExpanded} inBatch={inBatch} />);
			} else {
				var image = ImageStore.getImageById(item.getImageId());
				if (image) {
					image.setVisible(false);
				}
			}
		}

		//If the customer deletes all items on the last pagination page, switch to previous page
		if (items.length === 0 && this.state.page > 1) {
			this.setState({page: this.state.page-1});
		}

		var warningList = [];

		if(this.state.lowResWarning) {
			warningList.push(
				<div key="warning-lowres" className="modal-warning-block">
					<header>
						<h4><div className="ope-icon ope-icon--lowres"></div><span>{_("Low resolution images")}</span></h4>
					</header>
					<div className="main">
						<div className="ope-modal__product-list">
							<p>{_("You’ve uploaded one or more images at low resolution. These images might see loss in quality in print.")}</p>
							<p>{_("For better results, choose a smaller print size. Low resolution images have been marked with the icon displayed above.")}</p>
						</div>
					</div>
				</div>
			)
		}

		if(this.state.cropWarning) {
			warningList.push(
				<div key="warning-crop" className="modal-warning-block">
					<header>
						<h4><div className="ope-icon ope-icon--crop"></div><span>{_("Cropped photos")}</span></h4>
					</header>
					<div className="main">
						<div className="ope-modal__product-list">
							<p>{_("One or more photos have been cropped to fit the selected print size.")}</p>
							<p>{_("Cropped photos have been marked with the icon displayed above. We recommend that you check your cropped photos before ordering.")}</p>
						</div>
					</div>
				</div>
			);
		}

		var warnings;
		if (this.shouldShowWarnings()) {
			warnings = <Modal closeCallback={this._disableWarnings} id="product-list-warnings" show={true}>
							<div style={{padding: '10px'}}>
								<header>
									<h2>{_("Check your photos")}</h2>
								</header>
								<div className="main">
									<div className={warningList.length > 1 ? 'multiple-warnings' : ''}>
										{warningList}
									</div>
									<div style={{clear: 'both'}}></div>
								</div>
								<footer className="text-center">
									<TouchButton className="button small" onTap={this._disableWarnings}>
										{_("Got it!")}
									</TouchButton>
								</footer>
							</div>

						</Modal>
		}

		return (
			<div style={{position: 'relative', marginTop: '50px'}}>
				{ warnings }

				<Batch toggleCallback={this.batchToggleHandler} expanded={this.state.batchExpanded} />

				<article className="ope-product-list">
					<div id="ope-product-list__items" className="ope-product-list__items">
						{items}
					<div style={{'marginLeft': '9px'}}>
						<Paginator perPage={this.state.perPage} itemCount={this.state.items.length} page={this.state.page} pageClickCallback={this.updatePage}/>
					</div>
					</div>


					<footer id="ope-product-list__footer" className="ope-section__footer">
						<div className="ope-section__footer__seperator">
			            	<span className="ope-section__footer__seperator-line" />
			            	<span className="ope-section__footer__seperator-label">{ _("Do more with your photos") } </span>
			            	<span className="ope-section__footer__seperator-line" />
			          	</div>

						<ProductListTotal items={this.state.items} />
						<nav className="ope-section__footer__nav row">
							<div className="small-12 medium-6 medium-push-6 columns ope-grid-column-nopadding" style={{textAlign: 'right'}}>
								<TouchLink href="/upsale" id="gotoUpsaleButton" className="button ope-next-button arrow-right" disabled={!this.state.navEnabled}>
									{_("Finish your order")}
									<i className="icon arrow-right"></i>
								</TouchLink>
							</div>

							<div className="small-12 medium-6 medium-pull-6 columns ope-grid-column-nopadding">
								{/*<TouchLink href="/editor" className="ope-link">{_("Save and finish later")}</TouchLink>*/}
							</div>
						</nav>
					</footer>
				</article>
			</div>
		);
	}
});

export default ProductList;
